import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerHeaderTitle, Dropdown, Field, Input, Option, Spinner } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

export default function AddStaffMemberDrawer(
    {
        open,
        setOpen
    }: {
        open: boolean;
        setOpen: (open: boolean) => void;
    }
) {
    return <>
        <Drawer position="end" open={open}>
            <DrawerHeader>
                <DrawerHeaderTitle
                    action={
                        <Button
                            appearance="subtle"
                            aria-label="Close"
                            icon={<Dismiss24Regular />}
                            onClick={() => setOpen(false)}
                        />
                        }>
            Add Staff Member
                </DrawerHeaderTitle>
            </DrawerHeader>
            <DrawerBody>
                <Field label="Second Life Username" required>
                    <Input type="text" placeholder="John Doe" />
                </Field>
                <Field label="Role" required style={{ marginTop: "1rem"}}>
                    <Dropdown defaultSelectedOptions={ ["csr"] } defaultValue="CSR">
                        <Option value="csr">CSR</Option>
                        <Option value="manager">Store Manager</Option>
                        <Option value="admin">Administrator</Option>
                    </Dropdown>
                </Field>
                <Field label="UUID" required style={{ marginTop: "1rem"}}>
                    <Input type="text" value="" disabled />
                </Field>

                <div>
                    <Spinner size="small" label="Finding staff member in Second Life..." labelPosition="below" style={{ marginTop: "2rem", display: "flex", justifyContent: "center", textAlign: "center" }} />
                </div>
            </DrawerBody>
            <DrawerFooter>
                <Button appearance="primary" onClick={() => setOpen(false)} disabled>Add</Button>
            </DrawerFooter>
        </Drawer>
    </>;
}